import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import Radios from './Radios';
import Profiles from './Profiles';
import { close, loadingflas, open } from '../redux/popupSlice';
import Select from './Select';

import { getMemberinfo, hpHypen, } from "../utils/utils";

import * as APIS from "../utils/service";

export default function AutocutomerSet(props) {

    const {
        setautocustomerpop=() => {},
        row={},
        rowDataSubmitreload=() => {},
        memberinfos={},
        myArr=[],
        togetherlist=[],
        togethersublist=[],
        categoryname=''
    } = props;
    console.log(row);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let togetherCount = 0;
    togetherlist?.map((x, i) => {
        let subArr = togethersublist.filter(item => item?.c_idx*1 === x?.idx*1);
        togetherCount = togetherCount+subArr?.length;
        
    });

    const [auto_status, setauto_status] = useState(row?.auto_status);   
    const [itemCounts, setitemCounts] = useState(myArr?.length+togetherCount);   
    const [saveComments, setsaveComments] = useState(`안녕하세요. ${row?.hp?.slice(-4)}님
고객님께서 의뢰하신 조건에 어울리는 ${categoryname} ${row?.sell_type} 매물이 ${(myArr?.length+togetherCount) > 7 ? 7 : myArr?.length+togetherCount}건 확인되었습니다.
언제든지 연락주시면 상담 도와드리겠습니다.

감사합니다.

${memberinfos?.compony?.title}
${memberinfos?.name} ${memberinfos?.rank}/${memberinfos?.level*1 === 1 ? '중개보조원' : '공인중개사'}
${hpHypen(memberinfos?.hp)}
`);   


    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    const aiMatchingSubmit = () => {

        let sender = {
            idx: row?.idx,
            auto_status: !auto_status,
        }

        console.log(sender);
        dispatch(loadingflas({ loading: false }));
        APIS.postData('/v1/customer/auto', sender).then(({ data }) => {
            console.log(data);
            if(data){
                //정보 다시 로드
                setauto_status(!auto_status);
                rowDataSubmitreload();
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(data);

            dispatch(
                open({
                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                    title: '알림',
                    button: "확인",
                    titleviewer: true,                 
                    alert: false,
                    onPress: () => {
                        dispatch(close());
                    },
                })
            );      

        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });         
    }


    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1003}}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setautocustomerpop(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop "> 
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee'}}>
                            <span>이탈고객 자동관리</span>
                            <button
                                onClick={() => {
                                    setautocustomerpop(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div 
                            className="mettingArea padding32"
                        >
                            <div
                                style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'flex-end' }}
                            >
                                <button
                                    onClick={() => {
                                        if(itemCounts < 1){
                                            dispatch(
                                                open({
                                                    component: '매칭 매물이 없어 이탈고객 자동관리를 실행할 수 없습니다.',
                                                    title: '알림',
                                                    button: '닫기',
                                                    titleviewer: true,                 
                                                    alert: true,
                                                    onPress: () => {
                                                        dispatch(close());
                                                        //aiMatchingSubmit();
                                                    },
                                                })
                                            );                                               
                                            return;
                                        }
                                        dispatch(
                                            open({
                                                component: auto_status === true ? '이탈고객 자동관리를 중단하시겠습니까?' : '이탈고객 자동관리를 시작하시겠습니까?',
                                                title: '알림',
                                                button: auto_status === true ? "중단" : "등록",
                                                buttonCencle: "취소",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(close());
                                                    aiMatchingSubmit();
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );                                            
                                    }}
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4}}
                                >
                                    <span>자동관리 {auto_status === true ? 'ON' : 'OFF'}</span>
                                    {auto_status === true ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM16 15C17.6569 15 19 13.6569 19 12C19 10.3431 17.6569 9 16 9C14.3431 9 13 10.3431 13 12C13 13.6569 14.3431 15 16 15Z" fill="#6164A5"/>
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M8 7C5.23858 7 3 9.23858 3 12C3 14.7614 5.23858 17 8 17H16C18.7614 17 21 14.7614 21 12C21 9.23858 18.7614 7 16 7H8ZM8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12C1 8.13401 4.13401 5 8 5ZM8 15C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9C9.65685 9 11 10.3431 11 12C11 13.6569 9.65685 15 8 15Z" fill="#CCCCCC"/>
                                    </svg>
                                    }
                                </button>
                            </div>

                            <div className='texts'>
                                고객의 희망 매물 조건과 일치하면<br />
                                카카오 알림톡을 자동으로 발송해주는 기능입니다.<br />
                                고객당 최대 3건까지 발송 가능합니다.<br />
                                (최대 발송건수 도달시 이용 불가)
                            </div>
                            <div className='tips'>
                                <div className='fontsize16 bolds'>TIP</div>
                                <div className='tipcontents margint8'>
                                    <span>1.</span>
                                    <p>이탈 고객도 어딘가에서는 계약하는 잠재 조객입니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>2.</span>
                                    <p>이탈 고객에게 매칭되는 매물이 있음을 알려 연락을 유도합니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>3.</span>
                                    <p>물건 정보는 제공하지 않으며 매칭되는 ‘건수’만 제공 됩니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>4.</span>
                                    <p>매주 화/금요일 오전 10시, 최대 3회 한도내에서 매칭되는 물건이 존재하는 경우에만 발송됩니다.</p>
                                </div>
                                <div className='tipcontents'>
                                    <span>4.</span>
                                    <p>과도한 매물 정보 요구를 방지하기 위해 최대 7건까지만 표기됩니다. (7건 초과시 7건으로 표기)</p>
                                </div>
                            </div>
                            <div style={{ width: '100%'}}>
                                <div className='bolds fontsize16'>기본내용</div>
                                <textarea 
                                    className='margint8'
                                    style={{
                                        width: '100%', padding: 12, height: 230, border: '1px solid #DDD', borderRadius: 4,
                                    }}
                                    readOnly={true}
                                    value={saveComments}
                                />
                            </div>
                            {/* 
                            <div style={{ width: '100%' }}>
                                <Button
                                    buttonTxt={'저장'}
                                    styles={{ 
                                    }} 
                                    onPress={() => { 
                                        dispatch(
                                            open({
                                                component: '등록하시겠습니까?',
                                                title: '알림',
                                                button: "등록",
                                                buttonCencle: "취소",       
                                                titleviewer: true,                 
                                                alert: false,
                                                onPress: () => {
                                                    dispatch(close());
                                                },
                                                onCancelPress: () => {
                                                    dispatch(close());
                                                }
                                            })
                                        );                           
                                    }}
                                />   
                            </div>
                             */}
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )    
}